// extracted by css-extract-rspack-plugin
export default {"iFrame":"PdfEditor_iFrame__qqTBm"};